module.exports = __webpack_public_path__ + "img/pejoheshgah.0868cb1.png";